import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'

const useRouteSearchHash = () => {
  const router = useRouter()
  const route = useRoute()

  const currentHash = computed(() => route.hash)
  const currentHashRawText = computed(() => route.hash.match(/^#(.*)?:/)?.[1])
  const currentHashPlainText = computed(() =>
    currentHash.value ? currentHash.value.replace('#', '') : '',
  )

  const updateHash = (text?: string) => {
    return router.push({
      name: 'tickets',
      hash: text ? `#${text}` : '',
      params: route.params,
      query: route.query,
    })
  }

  return {
    updateHash,
    currentHash,
    currentHashRawText,
    currentHashPlainText,
  }
}

export default useRouteSearchHash
